import { z } from 'zod';

export const CommercialRefreshResponseSchema = z.object({
  ok: z.literal(true),
  runId: z.string().min(1),
});
